<div class="container my-4">
	<ul ngbNav class="nav-tabs">
		<li [ngbNavItem]="1" role="presentation">
			<h3>
				<i
					*ngIf="
						tableTitle.includes('tiedostot') ||
						tableTitle.includes('Tiedostot')
					"
					class="bi bi-archive-fill me-2 text-primary"
				></i
				>{{ tableTitle }}
			</h3>
		</li>

		<!-- Media Type Filters -->
		<li ngbDropdown class="nav-item ms-auto d-flex align-items-center" role="presentation">
			<button type="button" class="btn btn-sm fs-5" ngbDropdownToggle>
				<i class="bi bi-filter me-1"></i>
				<span
					class="badge bg-primary"
					*ngIf="getInactiveFilterCount() > 0"
				>
					{{ getInactiveFilterCount() }}
				</span>
			</button>
			<div ngbDropdownMenu>
				<button
					ngbDropdownItem
					(click)="showFolders = !showFolders; updateFilters()"
				>
					<i *ngIf="showFolders" class="bi bi-check me-2"></i>
					<i *ngIf="!showFolders" class="bi bi-square me-2" style="visibility: hidden;"></i>
					Tagit
				</button>
				<button
					ngbDropdownItem
					(click)="showFileMedia = !showFileMedia; updateFilters()"
				>
					<i *ngIf="showFileMedia" class="bi bi-check me-2"></i>
					<i *ngIf="!showFileMedia" class="bi bi-square me-2" style="visibility: hidden;"></i>
					Dokumentit
				</button>

				<button
					ngbDropdownItem
					(click)="showImageMedia = !showImageMedia; updateFilters()"
				>
					<i *ngIf="showImageMedia" class="bi bi-check me-2"></i>
					<i *ngIf="!showImageMedia" class="bi bi-square me-2" style="visibility: hidden;"></i>
					Kuvat
				</button>

				<button
					ngbDropdownItem
					(click)="showAudioMedia = !showAudioMedia; updateFilters()"
				>
					<i *ngIf="showAudioMedia" class="bi bi-check me-2"></i>
					<i *ngIf="!showAudioMedia" class="bi bi-square me-2" style="visibility: hidden;"></i>
					Ääni
				</button>
			</div>
		</li>

		<!-- Display Mode Selector -->
		<li ngbNavItem class="pe-2 d-none">
			<label class="form-label pe-2 d-none d-lg-inline">Näyttötapa</label>
			<div class="btn-group" role="group">
				<input
					type="radio"
					class="btn-check"
					name="displayMode"
					id="groupedMode"
					[value]="'grouped'"
					[(ngModel)]="displayMode"
					(ngModelChange)="onDisplayModeChange('grouped')"
					autocomplete="off"
				/>
				<label
					class="btn btn-outline-secondary btn-sm"
					for="groupedMode"
				>
					<!-- grouped icon -->
					<i class="bi bi-columns"></i>
				</label>
				<!-- 
				<input
					type="radio"
					class="btn-check"
					name="displayMode"
					id="foldersMode"
					[value]="'folders'"
					[(ngModel)]="displayMode"
					(ngModelChange)="onDisplayModeChange('folders')"
					autocomplete="off"
				/> -->

				<input
					type="radio"
					class="btn-check"
					name="displayMode"
					id="hierarchyMode"
					[value]="'hierarchy'"
					[(ngModel)]="displayMode"
					(ngModelChange)="onDisplayModeChange('hierarchy')"
					autocomplete="off"
				/>
				<label
					class="btn btn-outline-secondary btn-sm"
					for="hierarchyMode"
					title="Hierarkia"
				>
					<i class="bi bi-diagram-3"></i>
				</label>
			</div>
		</li>

		<li ngbDropdown class="nav-item d-none d-lg-inline d-flex align-items-center" role="presentation">
			<button type="button" class="btn btn-sm fs-5" ngbDropdownToggle>
				<i class="bi bi-tags me-1"></i>
				<span
					class="badge bg-primary"
					*ngIf="getSearchFieldTags(searchText).length > 0"
				>
					{{ getSearchFieldTags(searchText).length }}
				</span>
			</button>
			<div ngbDropdownMenu>
				@for (tag of sourceMaterialService.Tags; track tag) {
					<button
						ngbDropdownItem
						(click)="onToggleTag(tag.name)"
						[class.active]="isTagSelected(tag.name)"
						[ngbTooltip]="tag.description"
						[disableTooltip]="!tag.description || tag.description === ''"
						placement="right"
					>
						<!-- If selected, draw a check mark -->
						<i
							*ngIf="isTagSelected(tag.name)"
							class="bi bi-check"
						></i>
						{{ tag.name }}
					</button>
				}
				<div class="dropdown-divider"></div>
				<button ngbDropdownItem (click)="onManageTags()">
					<i class="bi bi-tags me-1"></i>
					Muokkaa tageja...
				</button>
			</div>
		</li>

		<li ngbNavItem>
			<form class="form-inline">
				<div class="input-group">
					<input
						class="form-control"
						type="search"
						placeholder="Hae"
						aria-label="Hae"
						[ngModel]="searchText"
						(ngModelChange)="updateSearch($event)"
						[name]="'searchText' + owner"
					/>
				</div>
			</form>
		</li>

		<li ngbNavItem *ngIf="showFileUpload">
			<button
				type="button"
				class="btn btn-primary btn-sm ms-2"
				(click)="openFileUploadModal()"
			>
				<i class="bi bi-cloud-upload"></i>
				Lataa kuvia...
			</button>
		</li>
	</ul>

	<!-- FOLDERS MODE -->
	<div *ngIf="displayMode === 'folders'" class="mt-3">
		<div class="row g-2">
			@for (
				item of getUniqueTagsWithCounts();
				track item.tag.id;
				let i = $index
			) {
				<div class="col-6 col-sm-4 col-md-3 col-lg-2">
					<div
						class="folder-card-compact p-2 cursor-pointer"
						[class.disabled]="item.disabled"
						(click)="
							item.disabled ? null : onFolderClick(item.tag.name)
						"
					>
						<div class="d-flex align-items-center">
							<i
								class="bi bi-folder-fill folder-icon-compact me-2"
							></i>
							<div
								class="folder-content-compact flex-grow-1 min-width-0"
							>
								<div class="folder-title-compact d-flex align-items-center">
									<span class="text-truncate">{{ item.tag.name }}</span>
									<span class="flex-shrink-0 ms-1" [class.text-muted]="!isTagSelected(item.tag.name)">({{ item.count }})</span>
								</div>
								@if (
									item.tag.description &&
									item.tag.description !== item.tag.name
								) {
									<small
										class="text-muted d-block text-truncate"
									>
										{{ item.tag.description }}
									</small>
								}
							</div>
						</div>
					</div>
				</div>
			}
			@if (getUniqueTagsWithCounts().length === 0) {
				<div class="col-12 text-center py-4">
					<i class="bi bi-folder-x display-4 text-muted"></i>
					<p class="mt-2 text-muted mb-0">
						Ei tageja näytettävissä tiedostoissa
					</p>
				</div>
			}
		</div>
	</div>

	<!-- GROUPED MODE (handles both grouped and hierarchy) -->
	<div
		*ngIf="displayMode === 'grouped' || displayMode === 'hierarchy'"
		class="mt-3 position-relative"
	>
		<!-- Hierarchy-only elements -->
		<div *ngIf="displayMode === 'hierarchy'">
			<!-- Breadcrumb Navigation -->
			<nav aria-label="breadcrumb" class="mb-3 d-flex align-items-center">
				<!-- Back Arrow -->
				<button
					type="button"
					class="btn btn-link p-0 me-2 border-0"
					[disabled]="currentFolderPath.length === 0"
					(click)="goBack()"
					[class.text-muted]="currentFolderPath.length === 0"
					aria-label="Go back one level"
				>
					<i class="bi bi-chevron-left" style="font-size: 1.2rem"></i>
				</button>

				<ol class="breadcrumb mb-0">
					@for (
						breadcrumb of getBreadcrumbs();
						track breadcrumb.path.join("-")
					) {
						<li
							class="breadcrumb-item"
							[class.active]="breadcrumb.isLast"
							[attr.aria-current]="
								breadcrumb.isLast ? 'page' : null
							"
						>
							@if (breadcrumb.isLast) {
								{{ breadcrumb.name }}
							} @else {
								<button
									type="button"
									class="btn btn-link p-0 text-decoration-none border-0"
									(click)="
										navigateToBreadcrumb(
											breadcrumb.path.length
										)
									"
								>
									{{ breadcrumb.name }}
								</button>
							}
						</li>
					}
				</ol>
			</nav>
		</div>

		<!-- Folders section at the top -->
		@if (showFolders && getUniqueTagsWithCounts().length > 0) {
			<h4 class="group-title w-100">
				{{ displayMode === "hierarchy" ? "Kansiot" : "Tagit" }}
			</h4>
			<div class="row g-2 mb-4">
				@for (
					item of getUniqueTagsWithCounts();
					track item.tag.id;
					let i = $index
				) {
					<div class="col-6 col-sm-4 col-md-3 col-lg-2">
						<div
							class="folder-card-grouped ps-2 pt-2 pe-2 pb-1 cursor-pointer position-relative"
							[class.selected]="isTagSelected(item.tag.name)"
							[class.disabled]="item.disabled"
							[ngbTooltip]="
								item.tag.description &&
								item.tag.description !== item.tag.name
									? item.tag.description
									: ''
							"
							(click)="
								item.disabled
									? null
									: displayMode === 'hierarchy'
										? navigateToFolder(item.tag.id)
										: onFolderToggle(item.tag.name)
							"
						>
							<div class="d-flex align-items-center">
								<i
									class="bi bi-folder-fill folder-icon-grouped me-2"
								></i>
								<div
									class="folder-content-grouped flex-grow-1 min-width-0"
								>
									<div class="folder-title-grouped d-flex align-items-center">
										<span class="text-truncate">{{ item.tag.name }}</span>
										<span class="flex-shrink-0 ms-1" [class.text-muted]="!isTagSelected(item.tag.name)">({{ item.count }})</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				}
			</div>
		}

		@let documentArticles = GetDocumentArticles(filteredArticles);
		@let imageArticles = GetImageArticles(filteredArticles);
		@let videoArticles = GetVideoArticles(filteredArticles);
		@let audioArticles = GetAudioArticles(filteredArticles);

		<div ngbDropdown style="position: absolute; top: 0; right: 0">
			<button class="btn btn-sm btn-outline-secondary" ngbDropdownToggle>
				<i class="bi bi-three-dots-vertical"></i>
			</button>
			<div ngbDropdownMenu>
				<button
					ngbDropdownItem
					(click)="AddTagsToSelectedArticles()"
					[disabled]="
						sourceMaterialService.SelectedArticles.length === 0
					"
				>
					<i class="bi bi-tags me-2"></i>
					Lisää tagit valittuihin tiedostoihin...
				</button>
				<div class="dropdown-divider"></div>
				<button
					ngbDropdownItem
					(click)="
						DeleteArticles(sourceMaterialService.SelectedArticles)
					"
					[disabled]="
						sourceMaterialService.SelectedArticles.length === 0
					"
					class="text-danger"
				>
					<i class="bi bi-trash me-2"></i>
					Poista valitut tiedostot
				</button>
			</div>
		</div>

		<!-- Separator between Tagit and Dokumentit -->
		<hr
			class="my-4"
			*ngIf="showFolders && getUniqueTagsWithCounts().length > 0 && documentArticles.length > 0"
		/>

		<!-- Documents Section (pdf, doc, text) -->
		@if (documentArticles.length > 0) {
			<h4 class="group-title w-100">Dokumentit</h4>
			<div
				[ngClass]="{
					'scroll-container':
						imageArticles.length === 0 ||
						videoArticles.length === 0 ||
						audioArticles.length === 0,
				}"
			>
				<table class="table table-hover">
					<thead>
						<tr>
							<th scope="col">
								<button
									class="btn btn-sm btn-outline-secondary me-2"
									(click)="
										onSelectAll(
											GetDocumentArticles(
												filteredArticles
											)
										)
									"
								>
									<i class="bi bi-check"></i>
								</button>
							</th>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortArticles('title')"
							>
								Nimi
								<i
									class="ms-1"
									[ngClass]="getSortIcon('title')"
								></i>
							</th>
							<!-- <th scope="col">Kirjoittaja</th> -->
							<th
								scope="col"
								class="sortable-header"
								style="width: 170px; white-space: nowrap"
								(click)="sortArticles('dateCreated')"
							>
								Luotu
								<i
									class="ms-1"
									[ngClass]="getSortIcon('dateCreated')"
								></i>
							</th>
							<th
								scope="col"
								*ngIf="shouldShowActionsColumn"
								class="text-end"
							></th>
						</tr>
					</thead>
					<tbody>
						@for (
							article of documentArticles;
							track article.id;
							let i = $index
						) {
							<!-- Only render parent articles (non-child articles) and orphaned children in main loop, OR all articles if nestChildren is false -->
							@if (
								!nestChildren ||
								article.parentArticleId === -1 ||
								article.parentArticleId === undefined ||
								isOrphanedChildArticle(article)
							) {
								<tr
									[@fadeInImmediately]
									class="position-relative"
								>
									<th scope="row" class="text-nowrap">
										<div class="form-check">
											<input
												class="form-check-input checkbox-lg me-2"
												type="checkbox"
												[id]="owner + '_doc_check' + i"
												[checked]="
													IsArticleSelected(article)
												"
												(click)="
													onSelectArticles(
														[article],
														false
													)
												"
											/>
											<label
												class="form-check-label"
												[for]="owner + '_doc_check' + i"
											>
												<!-- {{ i + 1 }} -->
											</label>
										</div>
									</th>
									<td>
										<label
											class="form-check-label"
											[for]="owner + '_doc_check' + i"
										>
											<span class="fw-medium">{{
												article.title
											}}</span>
										</label>

										<!-- Child article count badge (outside label to prevent selection triggering) - only show if nestChildren is true -->
										@if (
											nestChildren &&
											getChildArticleCount(article.id) > 0
										) {
											<span
												class="badge bg-secondary ms-2 cursor-pointer"
												(click)="
													$event.stopPropagation();
													$event.preventDefault();
													toggleParentExpansion(
														article.id
													)
												"
												title="Näytä/piilota alakuvat"
											>
												{{
													getChildArticleCount(
														article.id
													)
												}}
												<i
													class="bi ms-1"
													[class.bi-chevron-down]="
														!isParentExpanded(
															article.id
														)
													"
													[class.bi-chevron-up]="
														isParentExpanded(
															article.id
														)
													"
												></i>
											</span>
										}
									</td>
									<!-- <td>{{ article.creator }}</td> -->
									<td class="text-nowrap">
										<span class="text-muted">
											{{
												article.dateCreated * 1000
													| date: "d.M.yyyy HH:mm"
											}}
										</span>
									</td>
									<td
										*ngIf="shouldShowActionsColumn"
										class="text-end text-nowrap"
									>
										<button
											class="btn btn-outline-secondary btn-sm"
											*ngIf="
												article.type !== 'text' &&
												showPreviewButton
											"
											[disabled]="
												isArticleBeingLoaded(article)
											"
											(click)="
												$event.stopPropagation();
												onEditArticle(article)
											"
											ngbTooltip="Esikatsele"
											placement="top"
											[openDelay]="800"
										>
											<i
												*ngIf="
													!isArticleBeingLoaded(
														article
													)
												"
												class="bi bi-eye"
											></i>
											<div
												*ngIf="
													isArticleBeingLoaded(
														article
													)
												"
												class="spinner-border spinner-border-sm"
												role="status"
											>
												<span class="visually-hidden"
													>Ladataan...</span
												>
											</div>
										</button>

										<button
											class="btn btn-outline-secondary btn-sm"
											*ngIf="showGenerateButton"
											(click)="
												$event.stopPropagation();
												onSelectArticles(
													[article],
													true
												);
												onStartExport()
											"
											ngbTooltip="Luo peli"
											placement="top"
											[openDelay]="800"
										>
											<i class="bi bi-stars"></i>
										</button>

										<button
											class="btn btn-outline-danger btn-sm"
											*ngIf="showDeleteButton"
											[disabled]="
												isArticleOrChildrenBeingDeleted(
													article
												)
											"
											(click)="
												$event.stopPropagation();
												confirmDeleteArticle(
													article,
													deleteConfirmModal
												)
											"
											ngbTooltip="Poista"
											placement="top"
											[openDelay]="800"
										>
											<i
												*ngIf="
													!isArticleOrChildrenBeingDeleted(
														article
													)
												"
												class="bi bi-trash"
											></i>
											<div
												*ngIf="
													isArticleOrChildrenBeingDeleted(
														article
													)
												"
												class="spinner-border spinner-border-sm"
												role="status"
											>
												<span class="visually-hidden"
													>Poistetaan...</span
												>
											</div>
										</button>

										<!-- Dropdown menu for additional actions -->
										<div
											class="btn-group"
											ngbDropdown
											container="body"
											role="group"
										>
											<button
												class="btn btn-outline-secondary btn-sm"
												ngbDropdownToggle
												(click)="
													$event.stopPropagation()
												"
												ngbTooltip="Lisää toimintoja"
												placement="top"
												[openDelay]="800"
											>
												<i
													*ngIf="
														!isPDFBeingExtracted(
															article
														)
													"
													class="bi bi-three-dots-vertical"
												></i>
												<div
													*ngIf="
														isPDFBeingExtracted(
															article
														)
													"
													class="spinner-border spinner-border-sm"
													role="status"
												>
													<span
														class="visually-hidden"
														>Ladataan...</span
													>
												</div>
											</button>

											<div ngbDropdownMenu>
												<button
													ngbDropdownItem
													*ngIf="
														article.type !==
															'text' &&
														showPreviewButton
													"
													[disabled]="
														isArticleBeingLoaded(
															article
														)
													"
													(click)="
														$event.stopPropagation();
														onEditArticle(article)
													"
												>
													<i
														class="bi bi-eye me-2"
													></i>
													Esikatsele
												</button>
												<button
													ngbDropdownItem
													*ngIf="showGenerateButton"
													(click)="
														$event.stopPropagation();
														onSelectArticles(
															[article],
															true
														);
														onStartExport()
													"
												>
													<i
														class="bi bi-stars me-2"
													></i>
													Luo peli
												</button>
												<button
													ngbDropdownItem
													*ngIf="
														article.type === 'pdf'
													"
													[disabled]="
														isPDFBeingExtracted(
															article
														)
													"
													(click)="
														$event.stopPropagation();
														onExtractPDFImages(
															article
														)
													"
												>
													<i
														class="bi bi-images me-2"
													></i>
													Poimi kuvat...
												</button>
												<button
													ngbDropdownItem
													*ngIf="showTagButton"
													(click)="
														$event.stopPropagation();
														onOpenFileSettings(
															article
														)
													"
												>
													<i
														class="bi bi-tags me-2"
													></i>
													Muokkaa tageja...
												</button>

												<div
													class="dropdown-divider"
												></div>

												<button
													ngbDropdownItem
													*ngIf="showDeleteButton"
													[disabled]="
														isArticleOrChildrenBeingDeleted(
															article
														)
													"
													(click)="
														$event.stopPropagation();
														confirmDeleteArticle(
															article,
															deleteConfirmModal
														)
													"
													class="text-danger"
												>
													<i
														class="bi bi-trash me-2"
													></i>
													Poista
												</button>
											</div>
										</div>
									</td>
								</tr>
							}

							<!-- Child articles from filteredArticles when parent is expanded (only if nestChildren is true) -->
							@if (
								nestChildren &&
								(article.parentArticleId === -1 ||
									article.parentArticleId === undefined) &&
								isParentExpanded(article.id) &&
								getChildArticleCount(article.id) > 0
							) {
								<!-- Thumbnail view for child articles -->
								@if (
									getChildViewMode(article.id) ===
									"thumbnails"
								) {
									<tr>
										<td
											[attr.colspan]="
												shouldShowActionsColumn ? 4 : 3
											"
											class="p-3 position-relative"
										>
											<!-- View mode toggle in top-right corner -->
											<div
												class="position-absolute top-0 end-0 mt-2 me-2"
												style="z-index: 10"
											>
												<div
													class="btn-group btn-group-sm"
													role="group"
													aria-label="View mode toggle"
												>
													<button
														type="button"
														class="btn"
														[class.btn-primary]="
															getChildViewMode(
																article.id
															) === 'thumbnails'
														"
														[class.btn-outline-secondary]="
															getChildViewMode(
																article.id
															) !== 'thumbnails'
														"
														(click)="
															$event.stopPropagation();
															childViewModes.set(
																article.id,
																'thumbnails'
															)
														"
														title="Näytä pienoiskuvina"
													>
														<i
															class="bi bi-images"
														></i>
													</button>
													<button
														type="button"
														class="btn"
														[class.btn-primary]="
															getChildViewMode(
																article.id
															) === 'list'
														"
														[class.btn-outline-secondary]="
															getChildViewMode(
																article.id
															) !== 'list'
														"
														(click)="
															$event.stopPropagation();
															childViewModes.set(
																article.id,
																'list'
															)
														"
														title="Näytä listana"
													>
														<i
															class="bi bi-list-ul"
														></i>
													</button>
												</div>
											</div>
											<div
												class="row g-2 justify-content-center"
											>
												@for (
													childArticle of filteredArticles;
													track childArticle.id;
													let j = $index
												) {
													@if (
														childArticle.parentArticleId ===
														article.id
													) {
														@let imageArticle =
															CastArticleToImage(
																childArticle
															);
														@if (imageArticle) {
															<div
																class="col-2 p-2"
															>
																<div
																	class="card w-100 h-100 position-relative"
																	[ngClass]="{
																		'border border-4 border-primary':
																			IsArticleSelected(
																				imageArticle
																			),
																	}"
																	(click)="
																		onSelectArticles(
																			[
																				imageArticle,
																			],
																			false
																		)
																	"
																	[ngbTooltip]="
																		imageArticle.title
																	"
																	placement="bottom"
																	[openDelay]="
																		500
																	"
																>
																	<!-- Spinner overlay for images being deleted -->
																	<div
																		class="delete-spinner-overlay"
																		*ngIf="
																			isArticleBeingDeleted(
																				imageArticle
																			)
																		"
																	>
																		<div
																			class="spinner-border text-danger"
																			role="status"
																		>
																			<span
																				class="visually-hidden"
																				>Poistetaan...</span
																			>
																		</div>
																	</div>
																	<!-- Display image -->
																	@if (
																		imageArticle
																	) {
																		@let imageURL =
																			sourceMaterialService.GetURLAsObject(
																				imageArticle.id
																			)
																				| async;
																		@if (
																			imageURL
																		) {
																			<img
																				class="card-img-top"
																				style="
																					height: 150px;
																					object-fit: contain;
																				"
																				[src]="
																					imageURL
																				"
																				alt="{{
																					imageArticle.title
																				}}"
																			/>
																		} @else {
																			<!-- Loading spinner while image is being fetched -->
																			<div
																				class="d-flex justify-content-center align-items-center"
																				style="
																					height: 150px;
																				"
																			>
																				<div
																					class="spinner-border text-primary"
																					role="status"
																				>
																					<span
																						class="visually-hidden"
																						>Ladataan
																						kuvaa...</span
																					>
																				</div>
																			</div>
																		}
																	}
																	<div
																		class="card-body"
																	>
																		<h5
																			class="card-title"
																			style="
																				font-size: 0.9rem;
																				white-space: nowrap;
																				overflow: hidden;
																				text-overflow: ellipsis;
																				margin-bottom: 0;
																			"
																			*ngIf="
																				imageArticle.title
																			"
																		>
																			{{
																				imageArticle.title
																			}}
																		</h5>
																		<div
																			class="top-right"
																			*ngIf="
																				shouldShowActionsColumn
																			"
																		>
																			<div
																				class="btn-group"
																			>
																				<button
																					class="btn btn-sm btn-outline-secondary"
																					*ngIf="
																						showPreviewButton
																					"
																					[disabled]="
																						isArticleBeingLoaded(
																							imageArticle
																						)
																					"
																					(click)="
																						$event.stopPropagation();
																						openImageModal(
																							imageArticle
																						)
																					"
																				>
																					<i
																						*ngIf="
																							!isArticleBeingLoaded(
																								imageArticle
																							)
																						"
																						class="bi bi-eye"
																					></i>
																					<div
																						*ngIf="
																							isArticleBeingLoaded(
																								imageArticle
																							)
																						"
																						class="spinner-border spinner-border-sm"
																						role="status"
																					>
																						<span
																							class="visually-hidden"
																							>Ladataan...</span
																						>
																					</div>
																				</button>
																				<button
																					class="btn btn-sm btn-outline-danger"
																					*ngIf="
																						showDeleteButton
																					"
																					[disabled]="
																						isArticleBeingDeleted(
																							imageArticle
																						)
																					"
																					(click)="
																						$event.stopPropagation();
																						DeleteArticle(
																							imageArticle
																						)
																					"
																				>
																					<i
																						*ngIf="
																							!isArticleBeingDeleted(
																								imageArticle
																							)
																						"
																						class="bi bi-trash"
																					></i>
																					<div
																						*ngIf="
																							isArticleBeingDeleted(
																								imageArticle
																							)
																						"
																						class="spinner-border spinner-border-sm"
																						role="status"
																					>
																						<span
																							class="visually-hidden"
																							>Poistetaan...</span
																						>
																					</div>
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														}
													}
												}
											</div>
										</td>
									</tr>
								}

								<!-- List view for child articles -->
								@if (getChildViewMode(article.id) === "list") {
									<!-- Toggle row for list view -->
									<tr>
										<td
											[attr.colspan]="
												shouldShowActionsColumn ? 4 : 3
											"
											class="p-0 position-relative"
										>
											<!-- View mode toggle in top-right corner -->
											<div
												class="position-absolute top-0 end-0 mt-2 me-2"
												style="z-index: 10"
											>
												<div
													class="btn-group btn-group-sm"
													role="group"
													aria-label="View mode toggle"
												>
													<button
														type="button"
														class="btn"
														[class.btn-primary]="
															getChildViewMode(
																article.id
															) === 'thumbnails'
														"
														[class.btn-outline-secondary]="
															getChildViewMode(
																article.id
															) !== 'thumbnails'
														"
														(click)="
															$event.stopPropagation();
															childViewModes.set(
																article.id,
																'thumbnails'
															)
														"
														title="Näytä pienoiskuvina"
													>
														<i
															class="bi bi-images"
														></i>
													</button>
													<button
														type="button"
														class="btn"
														[class.btn-primary]="
															getChildViewMode(
																article.id
															) === 'list'
														"
														[class.btn-outline-secondary]="
															getChildViewMode(
																article.id
															) !== 'list'
														"
														(click)="
															$event.stopPropagation();
															childViewModes.set(
																article.id,
																'list'
															)
														"
														title="Näytä listana"
													>
														<i
															class="bi bi-list-ul"
														></i>
													</button>
												</div>
											</div>
										</td>
									</tr>
								}
								@for (
									childArticle of filteredArticles;
									track childArticle.id;
									let j = $index
								) {
									@if (
										childArticle.parentArticleId ===
											article.id &&
										getChildViewMode(article.id) === "list"
									) {
										<tr
											[@fadeInImmediately]
											class="position-relative child-article"
											style="
												border-left: 4px solid #007bff;
												background-color: #f8f9fa;
											"
										>
											<th scope="row">
												<div class="form-check">
													<input
														class="form-check-input checkbox-lg me-2"
														type="checkbox"
														[id]="
															owner +
															'_child_doc_check' +
															i +
															'_' +
															j
														"
														[checked]="
															IsArticleSelected(
																childArticle
															)
														"
														(click)="
															onSelectArticles(
																[childArticle],
																false
															)
														"
													/>
													<label
														class="form-check-label"
														[for]="
															owner +
															'_child_doc_check' +
															i +
															'_' +
															j
														"
													>
														<!-- {{ i + 1 }}.{{ j + 1 }} -->
													</label>
												</div>
											</th>
											<td>
												<label
													class="form-check-label ms-3"
													[for]="
														owner +
														'_child_doc_check' +
														i +
														'_' +
														j
													"
												>
													<i
														*ngIf="
															childArticle.type ===
															'image'
														"
														class="bi bi-image text-muted"
													></i>
													<i
														*ngIf="
															childArticle.type ===
															'text'
														"
														class="bi bi-file-earmark-text text-muted"
													></i>
													<i
														*ngIf="
															childArticle.type ===
															'doc'
														"
														class="bi bi-file-earmark-word text-muted"
													></i>
													<i
														*ngIf="
															childArticle.type ===
															'pdf'
														"
														class="bi bi-file-earmark-pdf text-muted"
													></i>
													<span
														class="ms-2 text-muted"
														>{{
															childArticle.title
														}}</span
													>
												</label>
											</td>
											<td class="text-muted">
												{{
													childArticle.dateCreated *
														1000
														| date: "d.M.yyyy HH:mm"
												}}
											</td>
											<td
												class="text-end"
												*ngIf="shouldShowActionsColumn"
											>
												<div class="btn-group">
													<button
														class="btn btn-outline-secondary btn-sm"
														*ngIf="
															childArticle.type ===
																'image' &&
															showPreviewButton
														"
														(click)="
															$event.stopPropagation();
															openImageModal(
																childArticle
															)
														"
													>
														<i
															class="bi bi-eye"
														></i>
													</button>
													<button
														class="btn btn-outline-danger btn-sm"
														*ngIf="showDeleteButton"
														[disabled]="
															isArticleBeingDeleted(
																childArticle
															)
														"
														(click)="
															$event.stopPropagation();
															DeleteArticle(
																childArticle
															)
														"
													>
														<i
															*ngIf="
																!isArticleBeingDeleted(
																	childArticle
																)
															"
															class="bi bi-trash"
														></i>
														<div
															*ngIf="
																isArticleBeingDeleted(
																	childArticle
																)
															"
															class="spinner-border spinner-border-sm"
															role="status"
														>
															<span
																class="visually-hidden"
																>Poistetaan...</span
															>
														</div>
													</button>
												</div>
											</td>
										</tr>
									}
								}
							}
						}
					</tbody>
				</table>
			</div>
		}

		<!-- Separator between Dokumentit and Kuvat -->
		<hr
			class="my-4"
			*ngIf="documentArticles.length > 0 && imageArticles.length > 0"
		/>

		<!-- Images Section -->
		@if (imageArticles.length > 0) {
			<h4>Kuvat</h4>
			<div class="position-relative">
				<!-- View mode toggle in top-right corner -->
				<div
					class="position-absolute end-0 me-2"
					style="z-index: 10; top: -45px"
				>
					<div
						class="btn-group btn-group-sm"
						role="group"
						aria-label="View mode toggle"
					>
						<button
							type="button"
							class="btn"
							[class.btn-primary]="imageViewMode === 'thumbnails'"
							[class.btn-outline-secondary]="
								imageViewMode !== 'thumbnails'
							"
							(click)="
								$event.stopPropagation();
								imageViewMode = 'thumbnails'
							"
							title="Näytä pienoiskuvina"
						>
							<i class="bi bi-images"></i>
						</button>
						<button
							type="button"
							class="btn"
							[class.btn-primary]="imageViewMode === 'list'"
							[class.btn-outline-secondary]="
								imageViewMode !== 'list'
							"
							(click)="
								$event.stopPropagation(); imageViewMode = 'list'
							"
							title="Näytä listana"
						>
							<i class="bi bi-list-ul"></i>
						</button>
					</div>
				</div>

				@if (imageViewMode === "thumbnails") {
					<div
						class="row g-0 justify-content-center"
						[ngClass]="{
							'scroll-container':
								videoArticles.length === 0 ||
								audioArticles.length === 0,
						}"
					>
						@for (
							article of imageArticles;
							track article.id;
							let i = $index
						) {
							@let imageArticle = CastArticleToImage(article);
							@if (imageArticle) {
								<div class="col-2 p-2">
									<div
										class="card w-100 h-100 position-relative"
										[ngClass]="{
											'border border-4 border-primary':
												IsArticleSelected(imageArticle),
										}"
										(click)="
											onSelectArticles(
												[imageArticle],
												false
											)
										"
										[ngbTooltip]="imageArticle.title"
										placement="bottom"
										[openDelay]="500"
									>
										<!-- Spinner overlay for images being deleted -->
										<div
											class="delete-spinner-overlay"
											*ngIf="
												isArticleBeingDeleted(
													imageArticle
												)
											"
										>
											<div
												class="spinner-border text-danger"
												role="status"
											>
												<span class="visually-hidden"
													>Poistetaan...</span
												>
											</div>
										</div>
										<!-- Display image -->
										@if (imageArticle) {
											@let imageURL =
												sourceMaterialService.GetURLAsObject(
													imageArticle.id,
													Imagesizes.Thumb
												) | async;
											@if (imageURL) {
												<img
													class="card-img-top"
													style="
														height: 150px;
														object-fit: contain;
													"
													[src]="imageURL"
													alt="{{
														imageArticle.title
													}}"
												/>
											} @else {
												<!-- Loading spinner while image is being fetched -->
												<div
													class="d-flex justify-content-center align-items-center"
													style="height: 150px"
												>
													<div
														class="spinner-border text-primary"
														role="status"
													>
														<span
															class="visually-hidden"
															>Ladataan
															kuvaa...</span
														>
													</div>
												</div>
											}
										}
										<!-- @if (imageArticle.sourceType === "local") {
									<img
										class="card-img-top"
										style="height: 150px; object-fit: cover"
										[src]="imageArticle.localPath"
										alt="{{ imageArticle.title }}"
									/>
								} @else {
									<img
										class="card-img-top"
										style="height: 150px; object-fit: cover"
										[src]="imageArticle.url"
										alt="{{ imageArticle.title }}"
									/>
								} -->
										<div class="card-body">
											<h5
												class="card-title"
												style="
													font-size: 0.9rem;
													white-space: nowrap;
													overflow: hidden;
													text-overflow: ellipsis;
													margin-bottom: 0;
												"
												*ngIf="imageArticle.title"
											>
												{{ imageArticle.title }}
											</h5>
											<p class="card-text">
												<small
													class="text-muted"
													*ngIf="imageArticle.creator"
													>{{
														imageArticle.creator
													}}</small
												>
											</p>
											<div
												class="top-right"
												*ngIf="shouldShowActionsColumn"
											>
												<div class="btn-group">
													<button
														class="btn btn-sm btn-outline-secondary"
														*ngIf="
															showPreviewButton
														"
														[disabled]="
															isArticleBeingLoaded(
																imageArticle
															)
														"
														(click)="
															$event.stopPropagation();
															openImageModal(
																imageArticle
															)
														"
													>
														<i
															*ngIf="
																!isArticleBeingLoaded(
																	imageArticle
																)
															"
															class="bi bi-eye"
														></i>
														<div
															*ngIf="
																isArticleBeingLoaded(
																	imageArticle
																)
															"
															class="spinner-border spinner-border-sm"
															role="status"
														>
															<span
																class="visually-hidden"
																>Ladataan...</span
															>
														</div>
													</button>
													<button
														class="btn btn-sm btn-outline-secondary"
														*ngIf="showTagButton"
														(click)="
															$event.stopPropagation();
															onOpenFileSettings(
																imageArticle
															)
														"
													>
														<i
															class="bi bi-tags"
														></i>
													</button>
													<button
														class="btn btn-sm btn-outline-danger"
														*ngIf="showDeleteButton"
														[disabled]="
															isArticleBeingDeleted(
																article
															)
														"
														(click)="
															$event.stopPropagation();
															DeleteArticle(
																article
															)
														"
													>
														<i
															*ngIf="
																!isArticleBeingDeleted(
																	article
																)
															"
															class="bi bi-trash"
														></i>
														<div
															*ngIf="
																isArticleBeingDeleted(
																	article
																)
															"
															class="spinner-border spinner-border-sm"
															role="status"
														>
															<span
																class="visually-hidden"
																>Poistetaan...</span
															>
														</div>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						}
					</div>
				}

				<!-- List view for images -->
				@if (imageViewMode === "list") {
					<table class="table table-hover">
						<thead>
							<tr>
								<th scope="col">
									<button
										class="btn btn-sm btn-outline-secondary me-2"
										(click)="
											onSelectAll(
												GetImageArticles(
													filteredArticles
												)
											)
										"
									>
										<i class="bi bi-check"></i>
									</button>
								</th>
								<th
									scope="col"
									class="sortable-header"
									(click)="sortArticles('title')"
								>
									Nimi
									<i
										class="ms-1"
										[ngClass]="getSortIcon('title')"
									></i>
								</th>
								<th
									scope="col"
									class="sortable-header"
									style="width: 170px; white-space: nowrap"
									(click)="sortArticles('dateCreated')"
								>
									Luotu
									<i
										class="ms-1"
										[ngClass]="getSortIcon('dateCreated')"
									></i>
								</th>
								<th
									scope="col"
									*ngIf="shouldShowActionsColumn"
									class="text-end"
								></th>
							</tr>
						</thead>
						<tbody>
							@for (
								article of imageArticles;
								track article.id;
								let i = $index
							) {
								@let imageArticle = CastArticleToImage(article);
								@if (imageArticle) {
									<tr
										[@fadeInImmediately]
										class="position-relative"
									>
										<th scope="row" class="text-nowrap">
											<div class="form-check">
												<input
													class="form-check-input checkbox-lg me-2"
													type="checkbox"
													[id]="
														owner + '_img_check' + i
													"
													[checked]="
														IsArticleSelected(
															imageArticle
														)
													"
													(click)="
														onSelectArticles(
															[imageArticle],
															false
														)
													"
												/>
												<label
													class="form-check-label"
													[for]="
														owner + '_img_check' + i
													"
												>
													<!-- {{ i + 1 }} -->
												</label>
											</div>
										</th>
										<td>
											<label
												class="form-check-label"
												[for]="owner + '_img_check' + i"
											>
												<span class="fw-medium">{{
													imageArticle.title
												}}</span>
											</label>
										</td>
										<td>
											{{
												imageArticle.dateCreated * 1000
													| date: "d.M.yyyy HH:mm"
											}}
										</td>
										<td
											class="text-end"
											*ngIf="shouldShowActionsColumn"
										>
											<button
												class="btn btn-outline-secondary btn-sm me-1"
												*ngIf="showPreviewButton"
												[disabled]="
													isArticleBeingLoaded(
														imageArticle
													)
												"
												(click)="
													$event.stopPropagation();
													openImageModal(imageArticle)
												"
											>
												<i
													*ngIf="
														!isArticleBeingLoaded(
															imageArticle
														)
													"
													class="bi bi-eye"
												></i>
												<div
													*ngIf="
														isArticleBeingLoaded(
															imageArticle
														)
													"
													class="spinner-border spinner-border-sm"
													role="status"
												>
													<span
														class="visually-hidden"
														>Ladataan...</span
													>
												</div>
											</button>
											<button
												class="btn btn-outline-danger btn-sm"
												*ngIf="showDeleteButton"
												[disabled]="
													isArticleBeingDeleted(
														imageArticle
													)
												"
												(click)="
													$event.stopPropagation();
													DeleteArticle(imageArticle)
												"
											>
												<i
													*ngIf="
														!isArticleBeingDeleted(
															imageArticle
														)
													"
													class="bi bi-trash"
												></i>
												<div
													*ngIf="
														isArticleBeingDeleted(
															imageArticle
														)
													"
													class="spinner-border spinner-border-sm"
													role="status"
												>
													<span
														class="visually-hidden"
														>Poistetaan...</span
													>
												</div>
											</button>
										</td>
									</tr>
								}
							}
						</tbody>
					</table>
				}
				<div style="clear: both"></div>
			</div>
		}

		<!-- Separator between Kuvat and Video -->
		<hr
			class="my-4"
			*ngIf="imageArticles.length > 0 && videoArticles.length > 0"
		/>

		<!-- Audio & Video Section -->
		@if (videoArticles.length > 0) {
			<h4>Video</h4>
			<div>
				<button
					class="btn btn-sm btn-outline-secondary me-2"
					(click)="onSelectAll(GetVideoArticles(filteredArticles))"
				>
					<i class="bi bi-check"></i>
				</button>
			</div>
			<div
				class="row g-0"
				[ngClass]="{
					'scroll-container': audioArticles.length === 0,
				}"
			>
				@for (
					article of videoArticles;
					track article.id;
					let i = $index
				) {
					@let videoArticle = CastArticleToVideo(article);
					@if (videoArticle) {
						<div class="col-2 p-2">
							<div
								class="card position-relative"
								[ngClass]="{
									'border border-4 border-primary':
										IsArticleSelected(videoArticle),
								}"
								(click)="
									onSelectArticles([videoArticle], false)
								"
								style="width: 200px; float: left"
							>
								<!-- Spinner overlay for videos being deleted -->
								<div
									class="delete-spinner-overlay"
									*ngIf="isArticleBeingDeleted(videoArticle)"
								>
									<div
										class="spinner-border text-danger"
										role="status"
									>
										<span class="visually-hidden"
											>Poistetaan...</span
										>
									</div>
								</div>
								<!-- Display based on type -->

								<div class="card-body text-center pt-3">
									<i
										class="bi bi-film display-4 text-primary"
									></i>
								</div>

								<div class="card-body">
									<h5
										class="card-title"
										style="
											font-size: 0.9rem;
											white-space: nowrap;
											overflow: hidden;
											text-overflow: ellipsis;
											margin-bottom: 0;
										"
									>
										{{ videoArticle.title }}
									</h5>
									<p class="card-text">
										<!-- <small class="text-muted">{{
											videoArticle.creator
										}}</small> -->
									</p>
									<div
										class="top-right"
										*ngIf="shouldShowActionsColumn"
									>
										<div class="btn-group">
											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showPreviewButton"
												(click)="
													$event.stopPropagation();
													onSelectArticles(
														[videoArticle],
														true
													);
													onEditArticle(videoArticle)
												"
											>
												<i class="bi bi-play"></i>
											</button>
											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showGenerateButton"
												(click)="
													$event.stopPropagation();
													onSelectArticles(
														[videoArticle],
														true
													);
													onStartExport()
												"
											>
												<i
													class="bi bi-box-arrow-up"
												></i>
											</button>
											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showTagButton"
												(click)="
													$event.stopPropagation();
													onOpenFileSettings(
														videoArticle
													)
												"
											>
												<i class="bi bi-tags"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					}
				}
				<div style="clear: both"></div>
			</div>
		}

		<!-- Separator between Video and Ääni -->
		<hr
			class="my-4"
			*ngIf="videoArticles.length > 0 && audioArticles.length > 0"
		/>

		<!-- Audio & Video Section -->
		@if (audioArticles.length > 0) {
			<h4>Ääni</h4>
			<div>
				<button
					class="btn btn-sm btn-outline-secondary me-2"
					(click)="onSelectAll(GetAudioArticles(filteredArticles))"
				>
					<i class="bi bi-check"></i>
				</button>
			</div>
			<div
				class="row g-0"
				[ngClass]="{
					'scroll-container': false,
				}"
			>
				@for (
					article of audioArticles;
					track article.id;
					let i = $index
				) {
					@let audioArticle = CastArticleToAudio(article);
					@if (audioArticle) {
						<div class="col-2 p-2">
							<div
								class="card position-relative"
								[ngClass]="{
									'border border-4 border-primary':
										IsArticleSelected(audioArticle),
								}"
								(click)="
									onSelectArticles([audioArticle], false)
								"
								style="width: 200px; float: left"
							>
								<!-- Spinner overlay for audio being deleted -->
								<div
									class="delete-spinner-overlay"
									*ngIf="isArticleBeingDeleted(audioArticle)"
								>
									<div
										class="spinner-border text-danger"
										role="status"
									>
										<span class="visually-hidden"
											>Poistetaan...</span
										>
									</div>
								</div>
								<!-- Display based on type -->

								<!-- audio -->
								<div class="card-body text-center">
									<i
										class="bi bi-music-note-beamed display-4 text-success"
									></i>
								</div>

								<div class="card-body">
									<h5
										class="card-title"
										style="
											font-size: 0.9rem;
											white-space: nowrap;
											overflow: hidden;
											text-overflow: ellipsis;
											margin-bottom: 0;
										"
									>
										{{ audioArticle.title }}
									</h5>
									<!-- <p class="card-text">
										<small class="text-muted">{{
											audioArticle.creator
										}}</small>
									</p> -->
									<div
										class="top-right"
										*ngIf="shouldShowActionsColumn"
									>
										<div class="btn-group">
											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showPreviewButton"
												(click)="
													$event.stopPropagation();
													onSelectArticles(
														[audioArticle],
														true
													);
													onEditArticle(audioArticle)
												"
											>
												<i class="bi bi-play"></i>
											</button>
											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showGenerateButton"
												(click)="
													$event.stopPropagation();
													onSelectArticles(
														[audioArticle],
														true
													);
													onStartExport()
												"
											>
												<i
													class="bi bi-box-arrow-up"
												></i>
											</button>

											<button
												class="btn btn-sm btn-outline-secondary"
												*ngIf="showTagButton"
												(click)="
													$event.stopPropagation();
													onOpenFileSettings(
														audioArticle
													)
												"
											>
												<i class="bi bi-tags"></i>
											</button>

											<button
												class="btn btn-sm btn-outline-danger"
												*ngIf="showDeleteButton"
												[disabled]="
													isArticleBeingDeleted(
														audioArticle
													)
												"
												(click)="
													$event.stopPropagation();
													DeleteArticle(audioArticle)
												"
											>
												<i
													*ngIf="
														!isArticleBeingDeleted(
															audioArticle
														)
													"
													class="bi bi-trash"
												></i>
												<div
													*ngIf="
														isArticleBeingDeleted(
															audioArticle
														)
													"
													class="spinner-border spinner-border-sm"
													role="status"
												>
													<span
														class="visually-hidden"
														>Poistetaan...</span
													>
												</div>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					}
				}
				<div style="clear: both"></div>
			</div>
		}
	</div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Vahvista poisto</h5>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss()"
		></button>
	</div>
	<div class="modal-body">
		<p>Haluatko varmasti poistaa tiedoston?</p>
		<p class="text-muted mb-0">Tämän jälkeen tiedostoa ei voi enää palauttaa.</p>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss()"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-danger"
			(click)="modal.close('confirm')"
		>
			Poista
		</button>
	</div>
</ng-template>

<!-- Image Preview Modal -->
